export { default } from "./CohortInsightsSkillsTable";
